module.exports = __webpack_public_path__ + "static/media/Fabian.cde89747.jpg";